import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface DrawerOpenState {
    open: boolean
    setOpen: (state: boolean) => void
    toggleOpen: () => void
}

export const useDrawerOpenStore = create<DrawerOpenState>()(
    devtools(
        (set, get) => ({
            open: false,
            setOpen: (state) => set({ open: state }),
            toggleOpen: () => set({ open: !get().open }),
        }),
        {
            name: 'DrawerOpenStore',
        },
    ),
)

export const getDrawerOpen = (): boolean => useDrawerOpenStore.getState().open
export const setDrawerOpen = useDrawerOpenStore.getState().setOpen
export const toggleDrawerOpen = useDrawerOpenStore.getState().toggleOpen

export default useDrawerOpenStore
